import { object, string } from "yup";
import { AddressSchema, EmailSchema, NameSchema } from "@validation/user";
import {
  CitySchema,
  CreditCardSchema,
  ExpirationMonthSchema,
  ExpirationYearSchema,
} from "@validation/payments";
import { USD_CURRENCY_CODE } from "@const/payments";

export const initialValues = {
  firstName: "",
  lastName: "",
  nameOnCard: "",
  cardNumber: "",
  expirationMonth: "",
  expirationYear: "",
  country: "",
  postalCode: "",
  city: "",
  address1: "",
  address2: "",
  email: "",
  cvv2: "",
  currencyCode: USD_CURRENCY_CODE,
  amount: "0.01",
  countryCode: "",
  state: "",
  stateFull: "",
  ipAddress: "",
};

export const validationSchema = (stateRequired, postalCodes, errorT, labelT) =>
  object().shape({
    firstName: NameSchema.required(
      errorT("REQUIRED", { label: labelT("FIRST_NAME") }),
    ),
    lastName: NameSchema.required(
      errorT("REQUIRED", { label: labelT("LAST_NAME") }),
    ),
    email: EmailSchema,
    cardNumber: CreditCardSchema(errorT, labelT),
    expirationMonth: ExpirationMonthSchema(errorT, labelT),
    expirationYear: ExpirationYearSchema(errorT, labelT),
    cvv2: string()
      .required(errorT("REQUIRED", { label: "CVV" }))
      .min(3, errorT("CVV_3_CHARACTERS"))
      .max(3, errorT("CVV_3_CHARACTERS")),
    postalCode: string().test(
      "postalCode",
      errorT("INVALID_ZIP_CODE"),
      function (value) {
        const countryCode = this.parent.countryCode;

        const country = postalCodes.find(
          (postalCode) => postalCode.ISO === countryCode,
        );
        if (country && countryCode) {
          const zipCodeRegex = country?.Regex?.trim();
          const regex = new RegExp(zipCodeRegex);
          return regex.test(value);
        }
        if (!country && countryCode) {
          return new RegExp("^0000$\n").test(value);
        }
        return false;
      },
    ),
    city: CitySchema(errorT, labelT),
    address1: AddressSchema.required(
      errorT("REQUIRED", { label: labelT("ADDRESS") }),
    ),
    country: string().required(
      errorT("REQUIRED", { label: labelT("COUNTRY") }),
    ),
    stateFull: !stateRequired
      ? string()
      : string().required(errorT("REQUIRED", { label: labelT("STATE") })),
  });
